export default {
    baseStyle: {
        // Search Input
        formFlex: {
            alignItems: 'center',
            mb: 8
        },
        inputGroup: {
            flex: 1
        },
        inputLeftElement: {
            pointerEvents: 'none',
            width: 6,
            left: 1.5
        },
        searchIcon: {
            boxSize: 6
        },
        searchInput: {
            // For some reason textStyle is not working, I needed to add the units
            // base: 16px prevents iOS Safari from auto-zooming on input focus (min threshold is 16px)
            fontSize: {base: 'webLg', lg: 'webMd'},
            fontWeight: 'normal',
            lineHeight: '20px',
            height: 10,
            border: 'none',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeDefault',
            borderRadius: 0,
            pl: 9,
            pr: 12,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'webTypo.textTertiary'
        },
        closeButton: {
            variant: 'ghost',
            minWidth: 'none', 
            ml: 2
        },

        // Suggestions Grid
        suggestionsGrid: {
            templateColumns: {base: '1fr', md: 'repeat(4, 1fr)'},
            gap: {base: 4, lg: 6},
            mb: {base: 8, lg: 12}
        },
        suggestionStack: {
            align: 'start',
            spacing: 2
        },
        sectionHeading: {
            // For some reason textStyle is not working, I needed to add the units
            fontSize: 'webSm',
            color: 'webTypo.textTertiary',
            mb: 1
        },
        suggestionItem: {
            // For some reason textStyle is not working, I needed to add the units
            fontSize: 'webMd',
            cursor: 'pointer'
        },
        // Parent category suffix ("in Clothing") — small, regular, secondary per design
        suggestionItemParent: {
            fontWeight: 'normal',
            color: 'webTypo.textSecondary'
        },
        categorySkeleton: {
            height: '21px',
            width: '100%',
            borderRadius: 'md'
        },

        // Products Section
        productsHeading: {
            textStyle: 'webH3',
            mb: 4
        },
        mobileSkeletonFlex: {
            gap: 4
        },
        mobileSkeleton: {
            height: '200px',
            width: '48%',
            borderRadius: 'md'
        },
        desktopSkeletonFlex: {
            gap: 2,
            wrap: 'wrap'
        },
        desktopSkeletonBox: {
            width: '163px'
        },
        desktopSkeleton: {
            height: '150px',
            borderRadius: 'md'
        },
        desktopSkeletonText: {
            mt: 2,
            spacing: 2
        },
        swiperWrapper: {
            mx: {base: '-16px', md: 0},
            pb: {base: '32px', md: 0}
        },
        outerWrapper: {
            height: '100vh',
            overflowY: 'auto',
            padding: {base: '0 16px 16px'}
        },

        // Sticky header wrapper (toggle + input)
        stickyHeader: {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            bg: 'white',
            mx: {base: '-16px', lg: '-16px'},
            px: {base: '16px', lg: '16px'}
        },

        // Close button
        closeButtonWrapper: {
            justifyContent: 'flex-end'
        },

        // Mode toggle
        modeToggleWrapper: {
            mb: 8,
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            gap: 0,
            justifyContent: 'center'
        },
        modeToggleButton: {
            textStyle: 'labelXs',
            variant: 'unstyled',
            pb: 2,
            width: '50%',
            textAlign: 'center',
            borderBottom: '1px solid',
            borderColor: 'transparent',
            borderRadius: 0,
            height: 'auto',
            textTransform: 'capitalize',
            cursor: 'pointer'
        },
        modeToggleButtonActive: {
            borderColor: 'webTheme.strokeDefault',
        },

        // Default state suggestions (stacked: recent → trending)
        defaultSuggestionsStack: {
            align: 'start',
            spacing: 8,
            width: '100%',
            mb: {base: 8, lg: 12}
        },

        // Products grid (2-column, replaces swiper)
        productsGrid: {
            gap: 2,
            mb: {base: 8, lg: 12}
        },
        productCardSkeleton: {
            width: '100%',
            borderRadius: 'md'
        },
        productCardSkeletonText: {
            mt: 2,
            spacing: 2
        },

        // No results
        noResultsWrapper: {
            pb: 8,
        },
        noResultsText: {
            textStyle: 'bodyMdRegular',
            color: 'webTypo.textSecondary'
        },

        // Quick View button overlay on product card
        qvOverlay: {
            position: 'absolute',
            bottom: 2,
            right: 2,
            zIndex: 1,
            transition: 'opacity 0.2s',
            opacity: {base: 1, md: 0}
        },

        // Smart search placeholder
        smartSearchPlaceholder: {
            pt: 8
        }
    },
    variants: {
        'storePickupSearch': {
            formFlex: {
                mb: 2
            },
            searchInput: {
                textStyle: 'bodyMdRegular',
                color: 'wenTypo.textPrimary'
            }
        }
    }
}
